// components/Skills.js
import React from 'react';
import { SKILLS } from '../Constants';

const Skills = () => {
  return (
    <section id="skills" className="p-8 flex flex-col justify-center items-center w-full  bg-gradient-to-r from-blue-400 to-purple-600">
      <h2 className="text-3xl font-bold text-center mb-6">Skills</h2>
      <div className="grid  grid-cols-2 md:grid-cols-3 gap-12 bg-gradient-to-r from-blue-400 to-purple-600 p-4 shadow">
        {SKILLS.map((skill, index) => (
          <div key={skill.name} className="flex items-center">
          <img src={skill.image} alt={skill.name} className="w-8 h-8 " />
          <span className='font-medium text-lg ml-2'>{skill.name}</span>
      </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
